import React from 'react'
import _ from 'lodash'
import { Accordion, Table } from 'camino-react'

const TimesheetsReportAccordion = ({ data }) => {
  const accordionTableColumns = data.columns

  const accordionDetails = _.map(data.groupedTimesheets, (value, title) => ({
    title,
    subTitle: (
      <>
        <strong>
          Total Hours
          {' '}
        </strong>
        {_.round(
          _.sumBy(value, 'duration_hours'),
          2
        )}
        {' '}
        <strong>
          With deducted hours
          {' '}
        </strong>
        {_.round(
          _.sum(_.map(value, timesheet => (timesheet.duration_hours - (timesheet.utilization_deductable_minutes / 60)))),
          2
        )}
        {' '}
        <strong>
          Total chargeable hours
          {' '}
        </strong>
        {_.round(
          _(value).filter(timesheet => timesheet.chargeable === true).sumBy('duration_hours'),
          2
        )}
        {' '}
        <strong>
          Total non-chargeable hours
          {' '}
        </strong>
        {_.round(
          _(value).filter(timesheet => timesheet.chargeable === false).sumBy('duration_hours'),
          2
        )}
      </>
    ),
    content: (
      <Table
        columns={accordionTableColumns}
        data={value}
        localStoragePrefix="TimesheetsReportAccordionItems"
      />
    )
  }))

  return (
    <div>
      <Accordion>
        {accordionDetails}
      </Accordion>
    </div>
  )
}

export default TimesheetsReportAccordion
